import React, {createContext, useContext, useEffect, useRef, useState} from 'react';
import {
    DEFAULT_GRID_PAGINATION_SIZE,
    SELECTED_PAGINATION_SIZE
} from "../../utils/Constants";
import {getSessionAttribute, setSessionAttribute} from "../../utils/SessionUtils";
import {SecurityContext} from "../security";

export const Context = createContext({})
export const Provider = props => {
    const {children} = props;
    const [exportColumns,setExportColumns] = useState();
    const [exportFilename,setExportFilename] = useState();
    const hiddenExportGridApi = useRef();
    const [paginationPageSize, setPaginationPageSize] = useState(DEFAULT_GRID_PAGINATION_SIZE);
    const [showButton, setShowButton] = useState(false)

    const {makeGetRequestNoParamsNew} = useContext(SecurityContext);


    const handleStreamPdf = (apiUrl,filename,e) => {
        e.preventDefault();
        const url = `${apiUrl}/stream`;

        const onSuccess = (response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            const newWindow = window.open(blobUrl, '_blank');

            if (newWindow) {

                //newWindow.location.href = blobUrl;
                // Clean up blob URL after window closes or timeout
                const cleanup = () => URL.revokeObjectURL(blobUrl);

                // Check if window is closed
                const checkClosed = setInterval(() => {
                    if (newWindow.closed) {
                        cleanup();
                        clearInterval(checkClosed);
                    }
                }, 1000);

                // Fallback cleanup after 10 minutes
                setTimeout(() => {
                    cleanup();
                    clearInterval(checkClosed);
                }, 600000);


            } else {
                window.open(blobUrl, '_blank');
            }

        };

        const onError = (error) => {
            console.error('Error streaming PDF:', error);
            if (error.response) {
                const status = error.response.status;
                if (status === 401) {
                    alert('Session expired. Please login again.');
                } else if (status === 403) {
                    alert('You do not have permission to access this document.');
                } else if (status === 404) {
                    alert('Document not found.');
                } else {
                    alert(`Error accessing document (${status}). Please try again.`);
                }
            } else {
                alert('Network error. Please check your connection.');
            }
        };

        makeGetRequestNoParamsNew(url, onSuccess, onError);
    };


    useEffect(() => {
        let paginationSize = getSessionAttribute(SELECTED_PAGINATION_SIZE);
        setPaginationPageSize(paginationSize? paginationSize : DEFAULT_GRID_PAGINATION_SIZE)
    }, [])

    const utilContext = {
        exportColumns,
        setExportColumns,
        hiddenExportGridApi,
        exportFilename,
        setExportFilename,
        paginationPageSize,
        setPaginationPageSize,
        showButton,
        setShowButton,
        handleStreamPdf
    }
    return <Context.Provider value={utilContext}>
        {children}
    </Context.Provider>

}
export const {Consumer} = Context;
